import React from 'react'

const SalesTemplates = ({projectId}:any) => {
  return (
    <div>SalesTemplates</div>
  )
}

export default SalesTemplates